<template>
  <Modal id="ServiceProviderDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('serviceProvider.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('serviceProvider.field.id_ser_pro')">{{data.idSerPro}}</DescriptionsItem>
      <DescriptionsItem :label="$t('serviceProvider.field.company_name')">{{data.companyName}}</DescriptionsItem>
      <DescriptionsItem :label="$t('serviceProvider.field.company_code')">{{data.companyCode}}</DescriptionsItem>
      <DescriptionsItem :label="$t('serviceProvider.field.create_date')">{{data.createDate}}</DescriptionsItem>
      <DescriptionsItem :label="$t('serviceProvider.field.status')">{{selectList.statusList.find(item=>item.value===data.status).label}}</DescriptionsItem>
      <DescriptionsItem :label="$t('serviceProvider.field.short_name')">{{data.shortName}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "ServiceProviderDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
        statusList: [{value: 0,label: 'Off'},{value:1,label: 'On'}],
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>